export default __webpack_public_path__ + "static/media/NunitoSans-SemiBold.662b8665.ttf";